import { render } from "./ApprovedPayments.vue?vue&type=template&id=7a0cb350"
import script from "./ApprovedPayments.vue?vue&type=script&lang=js"
export * from "./ApprovedPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__